import { render } from "./componentInformation.vue?vue&type=template&id=6225fc14&scoped=true"
import script from "./componentInformation.vue?vue&type=script&lang=js"
export * from "./componentInformation.vue?vue&type=script&lang=js"

import "./componentInformation.vue?vue&type=style&index=0&id=6225fc14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6225fc14"]])

export default __exports__